// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__Yp6rK","icon":"Skill_icon__XGJyV","title":"Skill_title__7v2J+","text":"Skill_text__MOnqU"};